export default __webpack_public_path__ + "static/media/not found.247f1681.svg";